import { PlatformEnum } from 'constants-activate';
import { IntegrationDefinition } from '../IntegrationDefinition';
import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

export const PointrDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Pointr,
  hasCustomUI: true,
  friendlyName: 'Pointr Maps',
  description: 'Provides Pointr SDK configuration to mobile.',
  category: IntegrationCategoryEnum.Custom,
  platforms: [PlatformEnum.Mobile],
  type: IntegrationTypeEnum.SDK,
  settings: {},
  properties: {
    clientId: {
      friendlyName: 'Pointr Client ID',
      type: 'String',
      validators: [{ name: 'Required', value: true }],
    },
    licenseKey: {
      friendlyName: 'Pointr License Key',
      type: 'String',
      validators: [{ name: 'Required', value: true }],
    },
    apiUrl: {
      friendlyName: 'Pointr API URL',
      type: 'String',
      validators: [{ name: 'Required', value: true }],
    },
    siteId: {
      friendlyName: 'Pointr Site ID',
      type: 'String',
      validators: [{ name: 'Required', value: true }],
    },
  },
};

export const definition = PointrDefinition;
